const LOADSUBSCRIPTIONPORTALURL =
  'twineApp/subscriptions/LOADSUBSCRIPTIONPORTALURL';
const LOADSUBSCRIPTIONPORTALURL_SUCCESS =
  'twineApp/subscriptions/LOADSUBSCRIPTIONPORTALURL_SUCCESS';
const LOADSUBSCRIPTIONPORTALURL_FAIL =
  'twineApp/subscriptions/LOADSUBSCRIPTIONPORTALURL_FAIL';

const CREATESUBSCRIPTIONTRANSACTION =
  'twineApp/subscriptions/CREATESUBSCRIPTIONTRANSACTION';
const CREATESUBSCRIPTIONTRANSACTION_SUCCESS =
  'twineApp/subscriptions/CREATESUBSCRIPTIONTRANSACTION_SUCCESS';
const CREATESUBSCRIPTIONTRANSACTION_FAIL =
  'twineApp/subscriptions/CREATESUBSCRIPTIONTRANSACTION_FAIL';

const initialState = {
  loading: false,
  loaded: false,
  subscriptionUrl: '',
  errors: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOADSUBSCRIPTIONPORTALURL:
      return { ...state, loading: true };
    case LOADSUBSCRIPTIONPORTALURL_SUCCESS:
      return {
        ...state,
        subscriptionUrl: action.result.url,
        loading: false,
        loaded: true,
      };
    case LOADSUBSCRIPTIONPORTALURL_FAIL:
      return { ...state, errors: action.errors, loading: false, loaded: true };
    default:
      return state;
  }
}

export function load() {
  return {
    types: [
      LOADSUBSCRIPTIONPORTALURL,
      LOADSUBSCRIPTIONPORTALURL_SUCCESS,
      LOADSUBSCRIPTIONPORTALURL_FAIL,
    ],
    promise: (client) => client.get(`/subscriptions/customer-portal`),
  };
}

/**
 * POST /users/:userId/subscription-transactions — log a subscription purchase.
 * Optional fields are omitted when undefined/null so they are not sent as empty form values.
 *
 * @param {number|string} userId
 * @param {object} body
 * @param {number} body.job_id — required
 * @param {number} [body.amount] — minor units (integer cents / pence)
 * @param {string} [body.currency]
 * @param {string} [body.ip_address]
 * @param {string} [body.coupon_code] — Stripe coupon id when auto-applied at checkout
 * @returns {object} Redux promise middleware action
 */
export function createSubscriptionTransaction(userId, body) {
  if (body == null || body.job_id === undefined || body.job_id === null) {
    throw new Error('job_id is required');
  }

  const { job_id, amount, currency, ip_address, coupon_code } = body;
  const data = { job_id };

  if (amount != null && amount !== '') {
    const n = Number(amount);
    if (Number.isFinite(n)) {
      data.amount = Math.round(n);
    }
  }
  if (currency != null) {
    data.currency = currency;
  }
  if (ip_address != null) {
    data.ip_address = ip_address;
  }
  if (coupon_code != null) {
    data.coupon_code = coupon_code;
  }

  return {
    types: [
      CREATESUBSCRIPTIONTRANSACTION,
      CREATESUBSCRIPTIONTRANSACTION_SUCCESS,
      CREATESUBSCRIPTIONTRANSACTION_FAIL,
    ],
    promise: (client) =>
      client.post(`/users/${userId}/subscription-transactions`, { data }),
  };
}
